/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MetricValuesOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("MetricValuesOperator");
    }

    getFixupPrototypeFunction() { return MetricValuesOperator.fixupPrototype; }

    static newInstance(model: Partial<MetricValuesOperator>): MetricValuesOperator {
        let obj = Object.assign(new MetricValuesOperator(), model);
        MetricValuesOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MetricValuesOperator>): MetricValuesOperator {
        if (!model) return null;
        return MetricValuesOperator.newInstance(<MetricValuesOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MetricValuesOperator) {
        if (!obj) return;

        models.MetricValuesOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MetricValuesOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MetricValuesOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Metrics for the findings
     */
    metrics: Array<number>;

}
